/**
 * LINE serializer (docs/opencadstudio-parity/01-native-dxf-export.md §3.1).
 * XLINE/RAY variants carry a truncated fake span in the data bag; the real
 * infinite geometry is a render-side concern, so they export as plain LINE
 * segments over the stored endpoints.
 */

import type { Entity } from '../../../../state/store';
import type { DxfWriteContext } from '../types';
import type { DxfStreamWriter } from '../DxfStreamWriter';
import { entityPrologue } from './common';

export function writeLine(w: DxfStreamWriter, ctx: DxfWriteContext, e: Entity, owner: string): void {
    const d = e.data as Record<string, unknown>;
    const start = d.start as number[], end = d.end as number[];
    if (!Array.isArray(start) || !Array.isArray(end)) return;
    entityPrologue(w, ctx, e, 'LINE', owner);
    w.pair(100, 'AcDbLine');
    w.pair(10, start[0] ?? 0).pair(20, start[1] ?? 0).pair(30, start[2] ?? 0);
    w.pair(11, end[0] ?? 0).pair(21, end[1] ?? 0).pair(31, end[2] ?? 0);
}
